<template>
  <div class="project-show" :style="screenStyleObject">
    <div class="header">
      <div class="left">
        <div class="title">按行业</div>
        <el-tabs class="project-tabs" v-model="activeTab" @tab-click="searchList">
          <el-tab-pane v-for="item in tabList" :key="item.name" :label="item.label" :name="item.name"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="right">
        <!-- <el-select style="width: 220px;" size="medium" v-model="search.address" placeholder="请选择" @change="getCardList"
          filterable>
          <el-option v-for="item in addressList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select> -->
        <el-cascader v-model="search.address" style="width: 220px;" :options="addressList" size="medium" filterable
          clearable @change="searchList" placeholder="请选择地址"></el-cascader>
        <el-input style="width: 220px;margin-left: 20px;" size="medium" placeholder="请输入工程名称"
          v-model="search.projectName" clearable @clear="searchList" @keyup.enter.native="searchList"
          @blur="searchList">
          <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer;" @click="searchList"></i>
        </el-input>
        <div class="total">共<span class="total-count">{{ total }}</span>个工程</div>
      </div>
    </div>
    <div class="content" v-if="cardList.length > 0">
      <PJShowCard v-for="card in cardList" :key="card.title" :card="card" />
    </div>
    <div class="no-data" v-else style="height: 300px;line-height: 300px;">
      暂无数据
    </div>
    <el-pagination class="project-page" @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="currentPage" :page-sizes="[9, 18, 27, 36]" :page-size="pageSize"
      layout="total,sizes, prev, pager, next, jumper" :total="total">
    </el-pagination>

  </div>
</template>

<script>
import PJShowCard from '@/components/PJShowCard.vue'
import { selectProjectTypeList, selectProjectPublishList } from '@/api/projectShow2'
import provinceCity from '@/assets/json/province_city'
import { mapGetters } from "vuex";
import debounce from "lodash/debounce";
export default {
  components: { PJShowCard },
  computed: {
    ...mapGetters(['getUserName']),
    styleObject() {
      let scale = this.scale;
      let obj = {
        width: window.innerWidth + "px",
        height: window.innerHeight + "px",
        backgroundColor: "#000",
      };
      return obj;
    },
    screenStyleObject() {
      let obj = {
        transform: `scale(${this.scale}) `,
        WebkitTransform: `scale(${this.scale}) `,
        transformOrigin: '0% 0%',
        width: this.width - 57 + "px",
        height: this.height + "px",
      };
      return obj;
    },
  },
  data() {
    return {
      width: 1920,
      height: 960,
      scale: this.getScale(),
      currentPage: 1,
      pageSize: 9,
      total: 0,
      tabList: [
        { name: "0", label: "全部" },
      ],
      activeTab: "0",
      search: {
        address: [],
        projectName: "",
      },
      addressList: [],
      cardList: [],
    }
  },
  methods: {
    getTabList() {
      selectProjectTypeList().then((res) => {
        this.tabList = [{ name: "0", label: "全部" }];
        res.returnData?.map((item) => {
          this.tabList.push({ name: String(item.projectTypeId), label: item.projectTypeName });
        })
      })
    },
    getCardList() {
      let data = {
        curPage: this.currentPage,
        pageSize: this.pageSize,
        username: this.getUserName,
      };
      if (this.activeTab !== 0) {
        data.projectTypeId = Number(this.activeTab);
      }
      if (this.search.address.length > 0) {
        data.provinceOrCityId = this.search.address[this.search.address.length - 1];
      }
      if (this.search.projectName) {
        data.projectName = this.search.projectName;
      }
      selectProjectPublishList(data).then((res) => {
        res = res.returnData
        this.total = res.count;
        this.cardList = [];
        res?.projectVos.map((item) => {
          let card = {
            id: item.id,
            title: item.projectName,
            type: item.projectTypeName,
            imageUrl: item.imsUrl,
            detail: item.projectBrief,
            address: item.province + item.city,
            links: [],
            userId: item.userId,
            uuid: item.uuid,
          };
          if (item.masterLink) {
            card.links.push({ title: '2.5D展示', url: item.masterLink, type: 'master' })
          }
          if (item.detailsLink) {
            card.links.push({ title: '数字孪生展示', url: item.detailsLink, type: 'digital' })
          }
          this.cardList.push(card)
        });
      });
    },
    searchList() {
      this.currentPage = 1;
      this.pageSize = 9;
      this.getCardList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getCardList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getCardList();
    },
    getScale() {
      // 固定好16:9的宽高比，计算出最合适的缩放比，宽高比可根据需要自行更改
      console.log(window.innerWidth, "window.innerWidth");
      let ww = window.innerWidth / this.width;
      let wh = window.innerHeight / this.height;

      return ww;
    },

    setScale: debounce(function () {
      // 获取到缩放比，设置它
      let scale = this.getScale();
      this.scale = scale;
      console.log(this.scale, "---");
    }, 1),
  },
  mounted() {
    if (isNaN(this.scale)) {
      this.scale = this.getScale();
    }
    this.addressList = provinceCity;
    this.getTabList();
    this.getCardList();
    window.addEventListener("resize", this.setScale);
  },
  beforeDestroy() {

    window.removeEventListener("resize", this.setScale);
  },
}
</script>

<style scoped lang="less">
.project-page.el-pagination {
  text-align: center;
  padding: 10px 0;

  /deep/ .el-pagination__total {
    font-size: 16px;
  }

  /deep/ .el-select,
  /deep/ .el-input,
  /deep/ .el-input__inner {
    height: 35px;
    font-size: 16px;
  }

  /deep/ button,
  /deep/ span:not([class*=suffix]) {
    height: 35px;
    line-height: 35px;
    font-size: 16px;
  }

  /deep/ .el-pager li {
    height: 35px;
    line-height: 35px;
  }
}

.content {
  padding: 10px 0 0 0;
  display: flex;
  flex-wrap: wrap;
}

.project-show {
  padding: 20px 20px 0 20px;
  min-height: auto;
  height: auto !important;
}

.header {
  background-color: #fff;
  height: 50px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  font-size: 20px;

  .title {
    font-weight: bold;
    color: #333;
    margin-right: 40px;
  }

  .left,
  .right {
    width: 50%;
    display: flex;
    align-items: center;
  }

  .right {
    justify-content: flex-end;

    .total {
      margin: 0 20px 0 40px;

      .total-count {
        font-size: 24px;
        color: #2066FF;
        font-weight: bold;
        margin: 0 10px;
      }
    }
  }
}

/deep/ .project-tabs .el-tabs__item {
  font-size: 20px;
  padding: 0 20px;
  color: #808080
}

/deep/ .project-tabs .el-tabs__nav-wrap {
  padding-left: 15px;
}

/deep/ .project-tabs .el-tabs__item.is-active {
  color: #2066FF;
  font-weight: bold;
}

/deep/ .project-tabs .el-tabs__item:hover {
  color: #2066FF;
  font-weight: bold;
}

/deep/ .project-tabs .el-tabs__active-bar {
  display: none;
}

/deep/ .project-tabs .el-tabs__header {
  margin: 0;
}

/deep/ .project-tabs .el-tabs__nav-wrap::after {
  display: none;
}
</style>